import React from 'react';

import { MarkdownContext } from 'app/src/components/TrelloMarkdown';
import { defaultStore } from 'app/gamma/src/defaultStore';
import { TrelloMarkdownWrapper } from 'app/gamma/src/util/trello-markdown-config';

const markdownWrapper = new TrelloMarkdownWrapper(defaultStore);

export const MarkdownProvider: React.FunctionComponent = ({ children }) => (
  <MarkdownContext.Provider value={markdownWrapper}>
    {children}
  </MarkdownContext.Provider>
);
